import Result from "slotworks/model/gameplay/records/results/result";
import Point from "slotworks/utils/geom/point";

export default class SymbolWinResult extends Result {

    public symbolType: string;

    public matches: number;

    public positions: Point[];
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/records/results/symbol-win-result.ts